import * as React from "react";
import { forwardRef } from "react";
const SvgLockOutlined = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 14 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	strokeWidth: 1.2,
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M3.5 8.167V4.833a3.333 3.333 0 0 1 6.667 0v3.334M1 9.833a1.667 1.667 0 0 1 1.667-1.666H11a1.667 1.667 0 0 1 1.667 1.666v5A1.666 1.666 0 0 1 11 16.5H2.667A1.667 1.667 0 0 1 1 14.833v-5Zm5 2.5a.833.833 0 1 0 1.667 0 .833.833 0 0 0-1.667 0Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgLockOutlined);
export default ForwardRef;
